/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_P1dInputs */

const en_mk_sol_operasional_p1d = /** @type {(inputs: Mk_Sol_Operasional_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When that person takes leave a step gets missed. The procedure exists in a document nobody opens.`)
};

const id_mk_sol_operasional_p1d = /** @type {(inputs: Mk_Sol_Operasional_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat orang itu cuti, langkah terlewat. Prosedurnya ada di dokumen yang jarang dibuka.`)
};

/**
* | output |
* | --- |
* | "When that person takes leave a step gets missed. The procedure exists in a document nobody opens." |
*
* @param {Mk_Sol_Operasional_P1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_p1d = /** @type {((inputs?: Mk_Sol_Operasional_P1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_P1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_p1d(inputs)
	return en_mk_sol_operasional_p1d(inputs)
});